// extracted by mini-css-extract-plugin
module.exports = {"pinchContainer":"pinch-zoom-image_pinchContainer__Ofgv3","iconContainer":"pinch-zoom-image_iconContainer__NZXxd","padded":"pinch-zoom-image_padded__31qKr"};